// extracted by mini-css-extract-plugin
export default {"footerLink":"SocialLinks_footerLink__1Y1IJ"};